








































































import {
  Component,
  Vue,
  Prop,
  Watch,
  Emit,
  PropSync,
} from "vue-property-decorator";
import FarmsList from "./FarmsList.vue";
import * as farmsService from "@/services/farms";
import { Farm } from "@/api/farms/types";
import { owner as ownerFactory, Owner } from "@/api/owner/types";
import ConfirmationModal from "@/components/confirmationModal/ConfirmationModal.vue";
import EventBus from "@/event-bus";
import Loading from "@/components/loading/Loading.vue";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";
import { formattedAreaInHa } from "@/filters/area";

@Component({
  name: "FarmsListController",
  components: {
    FarmsList,
    ConfirmationModal,
    loading: Loading,
    AgroIcons,
  },
   filters: {
    formattedAreaInHa,
  },
})
export default class FarmsListController extends Vue {
  private farm: Farm | null = null;
  private isConfirmationOpen: boolean = false;
  private isDeleting = false;
  private searchVisible = false;
  private search: string = "";
  private totalArea: number = 0;

  private get owner() {
    return this.$store.state.owner.ownerContext;
  }

  private get farmsList(): Farm[] {
    return this.$store.state.farms.farmsContext;
  }

  private get farmsStatus() {
    return this.$store.state.farms.status;
  }

  private get isLoadingOwner() {
    return this.$store.getters["owner/isLoadingOwner"];
  }

  private get hasOwner() {
    return !!this.owner && !this.isLoadingOwner;
  }

  private get isLoading() {
    return this.isLoadingOwner || this.farmsStatus === "fetching:farms";
  }

  private async mounted() {
    await this.fetchFarms(this.owner);
    EventBus.$on("update:farms", async () => {
      await this.fetchFarms(this.owner);
    });
  }

  @Watch("owner")
  private async ownerChanged(newOwner: Owner | null, oldOwner: Owner | null) {
    if (!!newOwner) {
      await this.fetchFarms(newOwner);
    } else {
      await this.clearFarms();
    }
  }

  private createFarm() {
    if (this.hasOwner && !this.isLoading) {
      this.$emit("create:farm");
    }
  }

  private async clearFarms() {
    await farmsService.clearFarms();
  }

  private async fetchFarms(owner: Owner) {
    await farmsService.getFarmsByOwner(owner);
  }

  private sendFarmForAnalysis(farm: Farm) {
    this.$emit("analysis:open", farm);
  }

  private sendAnalysisType(analysisType: string) {
    this.$emit("analysis:type", analysisType);
  }

  private removeFarm(farm: Farm) {
    this.farm = farm;
    this.isConfirmationOpen = true;
  }

  private async confirmRemoveFarm() {
    this.isDeleting = true;
    await farmsService.deleteFarm(this.farm!.uuid!);
    this.isConfirmationOpen = false;
    this.isDeleting = false;
    this.farm = null;
  }

  private cancelFarm() {
    this.isConfirmationOpen = false;
    this.farm = null;
  }

  private get filteredFarms() {
    const search = this.search;
    if (!search || search === "") {
      return this.farmsList;
    }
    return this.farmsList.filter((farmItem: Farm) => {
      const lowercasedSearch = search.toLocaleLowerCase();
      const toSearch = [
        farmItem.name,
        farmItem.cityName,
        farmItem.stateName,
        farmItem.stateAcronym,
      ]
        .filter((v) => !!v)
        .map((v) => (v as string).toLocaleLowerCase());

      return toSearch.some((str) => str.includes(lowercasedSearch));
    });
  }

  beforeUpdate() {
    this.sumFarmsTotalArea();
  }

  private sumFarmsTotalArea() {
    this.totalArea =  this.farmsList.reduce((n, {area}) => n + area, 0)
  }
}
